import React from 'react';
import Icon from '../../../components/AppIcon';

const DataUsageCard = ({ 
  title, 
  value, 
  unit, 
  percentage, 
  icon, 
  trend = null,
  className = '' 
}) => {
  const getTrendColor = () => {
    if (!trend) return '';
    return trend > 0 ? 'text-success' : trend < 0 ? 'text-error' : 'text-text-secondary';
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend > 0 ? 'TrendingUp' : trend < 0 ? 'TrendingDown' : 'Minus';
  };

  return (
    <div className={`bg-surface border border-border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon name={icon} size={18} className="text-primary" />
          <span className="text-sm font-medium text-text-primary">{title}</span>
        </div>
        {trend !== null && (
          <div className={`flex items-center space-x-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={14} />
            <span className="text-xs font-medium">{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <div className="flex items-baseline space-x-1">
          <span className="text-2xl font-bold text-text-primary">{value}</span>
          <span className="text-sm text-text-secondary">{unit}</span>
        </div>
        
        {percentage !== undefined && (
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${Math.min(percentage, 100)}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DataUsageCard;